import React, { useEffect, useState } from "react";
import { Handle } from "reactflow";
import "./CustomeNodeData.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "../Modal/Utility";
import { SpaRounded } from "@mui/icons-material";

const CustomNodeHL7Filter = ({ data }) => {

  return (
    <div className="custom-node">
      <div className="node-header">HL7 FILTER</div>
      <div>
        {data && data?.HL7_filter.map((item)=><div>{item}</div>)}
      </div>

      <Handle type="target" position="left" />
      <Handle type="source" position="right" />
    </div>
  );
};

export default CustomNodeHL7Filter;
